import { t, Trans } from '@lingui/macro';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as Sentry from '@sentry/browser';
import {getAccessToken2, getToken} from 'api/api';
import MainLogo from 'component/MainLogo';
import PolicyInfo from 'component/PolicyInfo';
import { setState } from 'config/Core';
import LocalStorage from 'config/LocalStorage';
import { showReportDialog } from 'config/SentryConfig';
import { getScope, handleApi } from 'helper/helper';
import { getCompanyDetailInfo, getCurrentSubs, getOwnerInfo } from 'helper/helper.js';
import { getNextPath } from 'helper/helperPermission';
import { stringify } from 'query-string';
import React, { PureComponent } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import connect from 'react-redux/es/connect/connect';
import { changeCompany } from 'redux/action';
import Routes from 'router/routes.js';
import DooPageWrapper from 'screen/Login/components/DoopageWrapper';
import ItopWrapper from 'screen/Login/components/ItopWrapper';
import DV from 'variables/DV';
import FacebookLogin from '../../component/FacebookLogin/FacebookLogin';
import Separator from '../../component/Separator';
import Button from '../../MUI_Kit/components/CustomButtons/Button';
import LoginByPasswordForm from './components/LoginByPasswordForm';
import { Link } from 'react-router-dom';
import { infoColor } from '../../variables/color';
import { default as decodeJWT } from 'jwt-decode'

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showNotifModal: false,
      loading: false,
    };
    this.clearLocalStorage();

    DV.token = '';
    DV.company = {};
  }

  clearLocalStorage = () => {
    let deviceId = LocalStorage.getStaffDeviceId();
    LocalStorage.clearLocal();
    LocalStorage.setStaffDeviceId(deviceId);
    DV.staffDeviceId = deviceId;
  };

  getToken = async (fbToken) => {
    this.setState({ loading: true });
    let { data, error } = await handleApi(getAccessToken2(fbToken));
    if (error || !data) {
      await setState(this)({ loading: false });
      this.showErrorMessage(error || 'Có lỗi xảy ra');
      return false;
    }

    let { access, refresh } = data;
    DV.token = access;
    const decodedToken = decodeJWT(access)
    DV.tokenExpireTime = new Date().getTime() + (decodedToken.exp - decodedToken.iat)*1000
    const decodedRefreshToken = decodeJWT(refresh);
    DV.refreshTokenExpireTime = new Date().getTime() + (decodedRefreshToken.exp - decodedRefreshToken.iat)*1000
    await LocalStorage.setToken(access);
    await LocalStorage.setToLocal('refreshToken',   refresh)
    await LocalStorage.setToLocal('tokenExpireTime',   DV.tokenExpireTime)
    await LocalStorage.setToLocal('refreshTokenExpireTime',  DV.refreshTokenExpireTime)
    return true;
  };

  findCompanyToLogin = () => {
    let companyToLogin;
    let { staffs, last_staff } = DV.owner;
    staffs = staffs || [];
    if (last_staff && last_staff.status === 'publish') {
      companyToLogin = last_staff;
    } else {
      staffs = staffs.filter((item) => item.status === 'publish');
      if (!staffs || staffs.length === 0) {
        this.redirectTo(Routes.company.path);
        return;
      }
      // tìm cty có quyền cao nhất
      let ownerCompany = staffs.find((item) => item.is_owner);
      if (ownerCompany) companyToLogin = ownerCompany;
      else {
        staffs.sort((a, b) => b.groups.length - a.groups.length);
        companyToLogin = staffs[0];
      }
    }
    return companyToLogin;
  };

  responseFacebook = async (response) => {
    if (!response.accessToken) return;

    let getTokenSuccess = await this.getToken(response.accessToken);
    if (!getTokenSuccess) return;
    this.handleGetTokenSuccess();
  };
  handleGetTokenSuccess = async () => {
    let { error } = await getOwnerInfo();
    if (error) {
      await setState(this)({ loading: false });
      this.showErrorMessage(error);
      return;
    }

    if (DV.params.invite_code) {
      this.redirectTo(Routes.joinCompany.path);
      return;
    }

    const companyToLogin = this.findCompanyToLogin();

    if (companyToLogin) {
      let { company, groups, is_owner } = companyToLogin;
      DV.company = company;
      DV.permission = groups;
      DV.isOwner = is_owner;

      let getCompanyDetailSuccess = await getCompanyDetailInfo();
      let getCurrentSubsSuccess = await getCurrentSubs();
      if (!(getCompanyDetailSuccess && getCurrentSubsSuccess)) {
        await setState(this)({ loading: false });
        return;
      }
      if (this.props?.location?.state?.next) {
        const { url, params } = this.props.location.state.next;
        this.redirectTo(url, params);
      } else {
        this.redirectTo(getNextPath(DV.url));
      }
      this.props.setCompany(DV.company);
    }
  };

  cancelAlert = () => {
    this.setState({ alert: null });
    const eventId = Sentry.captureException(new Error('Report Message From User'));
    showReportDialog(eventId);
  };

  showErrorMessage = (message) => {
    let classes = DV.classes;
    this.clearLocalStorage();
    DV.token = '';
    DV.company = {};

    this.setState({
      alert: (
        <SweetAlert
          danger
          title={t`Có lỗi xảy ra`}
          closeOnClickOutside
          onCancel={this.cancelAlert}
          onConfirm={() => this.setState({ alert: null })}
          confirmBtnCssClass={classes.button + ' ' + classes.gray}
          cancelBtnCssClass={classes.button + ' ' + classes.success}
          confirmBtnText={t`Đóng`}
          cancelBtnText={t`Liên hệ`}
          showCancel={this.props.online}
          style={{ color: 'black' }}>
          <div>{message}</div>
          <div>{t`Vui lòng nhấn Ctrl+F5 hoặc Cmd+F5 để tải lại trang`}</div>
        </SweetAlert>
      ),
    });
  };

  redirectTo = (path, params = {}) => {
    this.props.history.push({
      pathname: path,
      search: params ? stringify(params) : undefined ,
    } );
  };

  renderIcon = () => {
    if (this.state.loading) return <CircularProgress color="white" size={30} />;

    if (DV.withMobileDialog) return null;

    return <i className="fab fa-facebook-square" style={{ fontSize: 23 }} />;
  };

  getWrapper = () => {
    if (DV.partner === 'itop.website') return ItopWrapper;
    return DooPageWrapper;
  };

  render() {
    const { loading, alert } = this.state;
    const Wrapper = this.getWrapper();
    const isLoginByPassword = window.location.pathname === Routes.loginByPassword.path;
    return (
      <Wrapper>
        <div className="flex-center-col">
          {alert}
          <MainLogo />
          <Separator height={15} />
          {isLoginByPassword ? (
            <LoginByPasswordForm
              onSuccess={this.handleGetTokenSuccess}
              loading={loading}
              setLoading={(e) => this.setState({ loading: e })}
            />
          ) : (
            <FacebookLogin
              callback={this.responseFacebook}
              fields="name,email,picture"
              scope={getScope()}
              authType="reauthorize">
              {({ onClick, disabled }) => {
                return (
                  <Button
                    color="info"
                    onClick={onClick}
                    disabled={disabled || loading}
                    startIcon={<div className="flex-center-row">{this.renderIcon()}</div>}>
                    <span style={{ fontSize: 15 }}>{t`Đăng nhập Facebook`}</span>
                  </Button>
                );
              }}
            </FacebookLogin>
          )}

          <Separator height={15} />
          {!isLoginByPassword && (
            <div style={{ textAlign: 'center', padding: 5, color: infoColor }}>
              <Link to={Routes.loginByPassword.path}>
                <Trans>Đăng nhập bằng mật khẩu?</Trans>
              </Link>
            </div>
          )}
          <Separator height={15} />
          <div style={{ textAlign: 'center', padding: 5 }}>
            <Trans>Mọi thông tin bạn cung cấp luôn được bảo mật</Trans>
          </div>
        </div>
        <PolicyInfo />
      </Wrapper>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCompany: (company) => dispatch(changeCompany(company)),
  };
};

const mapStateToProps = (state) => {
  return {
    owner: state.common.owner,
    company: state.common.company,
    online: state.common.online,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
